import { priceBookIdFormat } from "@redotech/redo-ids-cockroach";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

export const updatePriceBookAccounts = unaryRpc({
  name: "updatePriceBookAccounts" as const,
  input: z.object({
    priceBookId: priceBookIdFormat.schema,
    teamIds: z.array(z.string()),
  }),
  output: z.object({ success: z.boolean() }),
});
